import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarCrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 38.55,
	height: 35.44,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m14.67 5.97 17.92 17.92a3.34 3.34 0 0 1 0 4.71l-2.83 2.84a3.34 3.34 0 0 1-4.72 0L7.12 13.5a3.34 3.34 0 0 1 0-4.72l2.83-2.82a3.34 3.34 0 0 1 4.72 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "m14.67 5.97-.48.47 17.93 17.92a2.67 2.67 0 0 1 0 3.77l-2.83 2.83a2.67 2.67 0 0 1-3.78 0L7.6 13.04a2.67 2.67 0 0 1 0-3.77l2.83-2.83a2.67 2.67 0 0 1 3.78 0zl.47-.47a4 4 0 0 0-5.66 0L6.65 8.32a4 4 0 0 0 0 5.66l17.92 17.93a4 4 0 0 0 5.66 0l2.83-2.83a4 4 0 0 0 0-5.66L15.14 5.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eff8fd",
			d: "M37.3 13.5 25.05 1.26A2 2 0 0 0 22.52 1l-7.7 5.12 17.6 17.6 5.13-7.7a2 2 0 0 0-.25-2.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M37.77 13.03 25.52.78a2.7 2.7 0 0 0-3.37-.33l-8.37 5.57 18.75 18.75 5.57-8.37a2.7 2.7 0 0 0-.33-3.36l-.94.94a1.3 1.3 0 0 1 .38.8v.14a1.3 1.3 0 0 1-.22.74l-4.67 7.02L15.87 6.23l7.03-4.67a1.3 1.3 0 0 1 .73-.23l.14.01a1.3 1.3 0 0 1 .8.38l12.26 12.26Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m14.2 19.64 4.71 4.72-.94.94-4.72-4.71z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "m13.72 19.17.95.94a.67.67 0 1 1-.95.95l-.94-.95a.67.67 0 1 1 .94-.94m4.72 4.72.94.94a.67.67 0 1 1-.94.94l-.95-.94a.67.67 0 1 1 .95-.94ZM16.55 22a.67.67 0 1 1-.94 0 .67.67 0 0 1 .94 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eff8fd",
			d: "m9.48 15.87.47.47a2 2 0 0 1 0 2.83l-.47.47a2 2 0 0 1-2.83 0l-.47-.47a2 2 0 0 1 0-2.83l.47-.47a2 2 0 0 1 2.83 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "m9.48 15.87-.47.47.47.47a1.34 1.34 0 0 1 0 1.89l-.47.47a1.33 1.33 0 0 1-1.9 0l-.46-.47a1.33 1.33 0 0 1 0-1.89l.47-.47a1.33 1.33 0 0 1 1.88 0zl.47-.47a2.67 2.67 0 0 0-3.77 0l-.48.47a2.67 2.67 0 0 0 0 3.77l.47.47a2.67 2.67 0 0 0 3.78 0l.47-.47a2.67 2.67 0 0 0 0-3.77l-.47-.47z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eff8fd",
			d: "m22.21 28.6.47.47a2 2 0 0 1 0 2.83l-.47.48a2 2 0 0 1-2.83 0l-.47-.48a2 2 0 0 1 0-2.82l.47-.48a2 2 0 0 1 2.83 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "m22.21 28.6-.47.48.47.47a1.34 1.34 0 0 1 0 1.88l-.47.48a1.33 1.33 0 0 1-1.89 0l-.47-.48a1.33 1.33 0 0 1 0-1.88l.47-.47a1.34 1.34 0 0 1 1.89 0zl.47-.47a2.67 2.67 0 0 0-3.77 0l-.47.47a2.67 2.67 0 0 0 0 3.78l.47.47a2.67 2.67 0 0 0 3.77 0l.48-.47a2.67 2.67 0 0 0 0-3.78l-.48-.47z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5edb3d",
			d: "M14.43 10.45a1.67 1.67 0 1 1-2.36 0 1.67 1.67 0 0 1 2.36 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6eee4d",
			d: "m14.43 10.44-.47.48a1 1 0 1 1-.7-.3 1 1 0 0 1 .7.3zl.47-.47a2.33 2.33 0 1 0 .69 1.65 2.3 2.3 0 0 0-.69-1.65z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5edb3d",
			d: "M28.1 24.13a1.67 1.67 0 1 1-2.35 0 1.67 1.67 0 0 1 2.36 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6eee4d",
			d: "m28.1 24.12-.46.47a1 1 0 1 1-.71-.29 1 1 0 0 1 .7.3zl.47-.47a2.34 2.34 0 1 0 .68 1.65 2.3 2.3 0 0 0-.68-1.65Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "m17.5 15.4 5.66 5.66a.67.67 0 0 1-.95.94l-5.66-5.66a.67.67 0 1 1 .95-.94m.68-6.71h14.67a.67.67 0 0 1 0 1.33H18.18a.75.75 0 0 1-.67-.76.6.6 0 0 1 .67-.57m3.3 3.33h14.67a.67.67 0 1 1 0 1.34H21.48a.7.7 0 0 1-.67-.73.6.6 0 0 1 .67-.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5edb3d",
			d: "m6.52 32.36-2.67 2.41v-3.53l-3.5-.54 3.24-2-1.76-3.08 3.39 1.04 1.3-3.3 1.3 3.3 3.39-1.04-1.77 3.08 3.25 2-3.5.53v3.54Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6eee4d",
			d: "m6.52 32.37-.64-.5-1.36 1.27v-1.85a.67.67 0 0 0-.57-.71l-1.51-.28 1.53-1.05a.67.67 0 0 0 .2-.89l-.92-1.6 1.77.54a.67.67 0 0 0 .82-.4l.68-1.72.68 1.73a.67.67 0 0 0 .82.39l1.78-.55-.93 1.61a.67.67 0 0 0 .2.89l1.53 1.05-1.52.28a.7.7 0 0 0-.56.7v1.86l-1.36-1.27a.9.9 0 0 0-1.1 0zl-.45.48 2.6 2.41a.8.8 0 0 0 .81.12.7.7 0 0 0 .38-.66V31.8l2.9-.44c.27-.04.2-.24.27-.51a.7.7 0 0 0-.27-.7l-2.43-1.66 1.46-2.54a.67.67 0 0 0-.77-.97l-2.8.86-1.08-2.72a.67.67 0 0 0-1.24 0l-1.08 2.72-2.8-.85a.67.67 0 0 0-.77.97l1.46 2.53-2.42 1.66a.7.7 0 0 0-.27.7c.06.27 0 .47.27.51l2.9.44v2.93a.7.7 0 0 0 .37.65.8.8 0 0 0 .81-.12l2.6-2.4zl-.45.5Z"
		})
	]
});
export default SvgCarCrash;
